import { getUserCourses_getUserCourses_edges } from './__generated__/getUserCourses';

export const transformYourCourses = (
  data: (getUserCourses_getUserCourses_edges | null)[],
) =>
  data?.map(
    (egdeNode: getUserCourses_getUserCourses_edges | null) => egdeNode?.node,
  ) || [];
